var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 51,
    viewBox: "0 0 76 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3858)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.7959H9.07155V22.5317H6.47052V29.1103H2.68874V22.5317H0V19.7959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6697 23.5587L11.7569 29.1105H8.12695L11.6895 19.7961H15.6298L19.2766 29.1105H15.6028L13.6697 23.5587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4101 19.7961H27.485V22.5319H24.8806V29.1105H21.1022V22.5319H18.4101V19.7961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0799 23.5587L30.1705 29.1105H26.5371L30.0996 19.7961H34.0433L37.6868 29.1105H34.013L32.0799 23.5587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29936 50.7824H0V37.4781C0 35.0132 1.34943 33.6587 3.60973 33.6587C5.21555 33.6587 6.24787 34.3276 7.25994 36.6687L11.595 46.856C11.7266 47.1604 11.8581 47.2707 12.0808 47.2707C12.1421 47.2771 12.204 47.2695 12.2618 47.2483C12.3196 47.2272 12.3717 47.1932 12.4141 47.1489C12.4565 47.1046 12.488 47.0512 12.5063 46.9929C12.5245 46.9346 12.529 46.8729 12.5194 46.8125V33.7791H15.8558V47.0834C15.8558 49.5483 14.557 50.9028 12.3136 50.9028C10.7077 50.9028 9.5641 50.2038 8.57227 47.8928L4.22372 37.6955C4.09215 37.3911 3.96058 37.2808 3.7413 37.2808C3.67978 37.2738 3.61746 37.2811 3.55923 37.3019C3.501 37.3228 3.44843 37.3568 3.40564 37.4011C3.36284 37.4455 3.33098 37.4991 3.31254 37.5577C3.29411 37.6163 3.2896 37.6783 3.29936 37.739V50.7824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2443 50.7822H21.7241C19.9192 50.7822 18.8633 49.7354 18.8633 47.9461V36.6049C18.8633 34.8156 19.9192 33.7688 21.7241 33.7688H31.2511V36.9962H22.9116C22.8252 36.9876 22.738 36.9979 22.6562 37.0264C22.5743 37.055 22.4998 37.1011 22.4379 37.1614C22.3761 37.2218 22.3284 37.2949 22.2983 37.3756C22.2682 37.4563 22.2565 37.5426 22.2639 37.6283V40.5079H30.8125V43.6484H22.2639V46.9226C22.2567 47.0075 22.2683 47.0928 22.2978 47.1727C22.3273 47.2526 22.374 47.3252 22.4347 47.3854C22.4954 47.4455 22.5686 47.4919 22.6492 47.5211C22.7298 47.5504 22.8159 47.5619 22.9015 47.5548H31.2342L31.2443 50.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2773 33.7791H37.688V44.0533C37.688 46.2339 39.3377 47.7824 41.5845 47.7824C43.8313 47.7824 45.4776 46.2339 45.4776 44.0533V33.7791H48.8883V44.0533C48.8883 48.0867 45.8285 51.0098 41.5845 51.0098C37.3406 51.0098 34.2773 48.0867 34.2773 44.0533V33.7791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 7.82904C52.3095 7.36341 52.4577 6.83027 52.4561 6.28723C52.4838 5.56689 52.2497 4.86064 51.7965 4.29691C51.3433 3.73317 50.7011 3.34939 49.9867 3.21535C49.2722 3.0813 48.533 3.2059 47.9034 3.56648C47.2737 3.92706 46.7955 4.49968 46.5558 5.18021L39.9267 21.4444C39.8265 21.6536 39.7735 21.8818 39.7715 22.1133C39.778 22.4644 39.8988 22.8041 40.1159 23.0816C40.3329 23.3591 40.6347 23.5596 40.9761 23.6532C41.3175 23.7469 41.6802 23.7286 42.0103 23.6012C42.3404 23.4737 42.6201 23.244 42.8077 22.9461L52.0277 7.82904Z",
    fill: "url(#paint0_linear_1_3858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4243 6.94273C46.2889 6.36022 46.3384 5.75046 46.566 5.19691C46.7914 4.59867 47.2028 4.08699 47.7409 3.73585C48.2789 3.38472 48.9157 3.21233 49.5591 3.2436C50.2024 3.27488 50.8191 3.50821 51.3199 3.90984C51.8207 4.31148 52.1797 4.86061 52.345 5.47784L58.7952 25.829C59.081 26.6541 59.1115 27.5451 58.883 28.3875C58.6205 29.3632 58.0292 30.2204 57.2072 30.8166C56.3852 31.4128 55.3822 31.7122 54.3648 31.6649C53.3474 31.6176 52.377 31.2266 51.6149 30.5567C50.8528 29.8868 50.3449 28.9785 50.1757 27.9829L46.4243 6.94273Z",
    fill: "url(#paint1_linear_1_3858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4771 8.69566C71.0677 7.67386 71.3301 6.49786 71.2294 5.32443C71.1165 4.02274 70.5653 2.79651 69.6645 1.84293C68.7636 0.889355 67.5654 0.263842 66.2626 0.0669786C64.9598 -0.129884 63.6281 0.113344 62.4815 0.75755C61.335 1.40176 60.4404 2.40951 59.9414 3.61874L50.4954 25.4415C50.0353 26.4873 50.0004 27.6688 50.3981 28.7395C50.7958 29.8101 51.5953 30.6871 52.6297 31.1873C53.664 31.6875 54.8533 31.7723 55.9492 31.4239C57.0451 31.0756 57.9629 30.321 58.511 29.3177L70.4771 8.69566Z",
    fill: "url(#paint2_linear_1_3858)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3858",
    x1: 40.6992,
    y1: 23.5916,
    x2: 50.627,
    y2: 3.50952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0096FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1680FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#4D49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7521FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#8D09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9600FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3858",
    x1: 48.1516,
    y1: 3.48453,
    x2: 55.6071,
    y2: 31.5536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9600FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B600DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DE00B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6009F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF0096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3858",
    x1: 52.6039,
    y1: 31.2174,
    x2: 67.7817,
    y2: 0.510392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF0096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FF1680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF4D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF7521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF8D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF9600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7bb803dea457371815d14bf45ebd9086.svg";
export { ForwardRef as ReactComponent };